import axios from "axios";

export default axios.create({
  baseURL: "https://api.intellitraffic.info/flask/",  // Update the base URL
  withCredentials: false,
});
